<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Kostki produkcyjne</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Kostki produkcyjne</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight logs">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isFiltersOpen = !isFiltersOpen">
            <h5>Filtry</h5>
            <span class="ibox-toggle">
              <i :class="chevronFiltersClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isFiltersOpen">
            <div class="row">
              <div class="col-md-7 nopadding">
                <div class="form-group">
                  <label for="order_pk" class="control-label col-sm-2">
                    Numer zamówienia
                  </label>
                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Numer zamówienia"
                      v-model="orderPk"
                    />
                  </div>
                </div>
              </div>
              <div
                class="col-md-3 nopadding"
                v-if="canDisplaySites && filterSites.length"
              >
                <div class="form-group">
                  <label class="control-label col-sm-2">Domena</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="sitePk"
                      mode="single"
                      placeholder="Domena"
                      track-by="value"
                      label="name"
                      :close-on-select="true"
                      :searchable="true"
                      :options="filterSites"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isMainOpen = !isMainOpen">
            <h5>Kostki produkcyjne</h5>
            <span class="ibox-toggle">
              <i :class="chevronMainClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddMontage" to="/montages/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div v-if="items" class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input
                      type="number"
                      v-model.number="serverOptions.page"
                      @change="
                        serverOptions.page = clampPage(serverOptions.page)
                      "
                    />
                    -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="selectPage(serverOptions.page - 1)"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="selectPage(serverOptions.page + 1)"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
            <div v-if="items" class="row">
              <router-link
                :to="'/cubes/details/' + item.pk"
                v-for="(item, index) in items"
                :key="index"
                class="col-sm-3 m-b-xs no-decoration"
              >
                <div class="widget lazur-bg p-xl">
                  <span class="badge badge-light">{{ item.site_name }}</span>
                  <b>
                    <h2>
                      {{
                        (serverOptions.page - 1) * serverOptions.rowsPerPage +
                        index +
                        1
                      }}.
                      {{ item.machine_name }}
                    </h2>
                    <small></small>
                  </b>
                  <ul class="list-unstyled m-t-md">
                    <li>
                      <span>{{ item.machine_action_name }}</span>
                    </li>
                    <li>
                      <label>Liczba zleceń: </label>
                      <span>{{ item.products_count }}</span>
                    </li>
                    <li>
                      <span>{{ item.realization_date }}</span>
                    </li>
                  </ul>
                </div>
              </router-link>
            </div>
            <!-- Paginacja pod listą -->
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input
                      type="number"
                      v-model.number="serverOptions.page"
                      @change="
                        serverOptions.page = clampPage(serverOptions.page)
                      "
                    />
                    -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="selectPage(serverOptions.page - 1)"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="selectPage(serverOptions.page + 1)"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { getPermittedSiteIds, hasPermission } from "../../permissions";
import { processStagePermissionsConst } from "../../constants/processConstants";
import { montagePermissionsConst } from "../../constants/productionConstants";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import {
  getSiteValueFromCurrentUrl,
  hasSiteOptionValue,
} from "../../site-domain";

export default {
  name: "CubesList",
  mixins: [],
  components: {
    Multiselect,
  },
  props: {},

  setup() {
    const store = useStore();
    // The add button leads to the montage form.
    const canAddMontage = computed(() =>
      hasPermission(montagePermissionsConst.add)
    );
    // Production cubes are process stages - the old panel shows the domain
    // filter only when they may be viewed on more than one site.
    const permittedSiteIds = getPermittedSiteIds(
      processStagePermissionsConst.view
    );
    const canDisplaySites = computed(() => permittedSiteIds.length > 1);
    const cubesData = computed(() => store.getters.getCubesData);
    const sitesData = computed(() => store.getters.getSitesData);

    const loading = ref(true);
    const mActions = ref(false);
    const isFiltersOpen = ref(true);
    const isMainOpen = ref(true);
    let items = ref([]);
    let itemsAll = ref(0);
    const orderPk = ref("");
    const sitePk = ref();
    const filterSites = ref([]);
    const siteFilterInitialized = ref(false);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
    });
    let orderPkTimeout = null;

    const getCubes = async () => {
      if (!siteFilterInitialized.value) {
        return;
      }
      loading.value = true;
      const payload = {
        page: serverOptions.value.page,
        page_size: serverOptions.value.rowsPerPage,
      };

      if (orderPk.value) {
        payload.order_pk = orderPk.value;
      }

      if (sitePk.value) {
        // Multiselect z track-by="value" zwraca obiekt { name: ..., value: ... }
        payload.site_pk =
          typeof sitePk.value === "object" && sitePk.value.value
            ? sitePk.value.value
            : sitePk.value;
      }

      await store.dispatch("getCubes", payload);
    };

    onMounted(() => {
      store.dispatch("getSites");
    });

    watch(
      () => cubesData.value,
      function (newValue) {
        if (newValue?.data) {
          itemsAll.value = newValue.data.count || 0;
          items.value = [];
          newValue.data.results?.forEach((element) => {
            items.value.push(element);
          });
        }
        loading.value = false;
      }
    );

    watch(
      () => sitesData.value,
      function (newValue) {
        const raw = Array.isArray(newValue?.data?.results)
          ? newValue.data.results
          : Array.isArray(newValue?.data?.data)
          ? newValue.data.data
          : Array.isArray(newValue?.data)
          ? newValue.data
          : [];
        filterSites.value = raw
          .filter((s) => permittedSiteIds.includes(s.pk))
          .map((s) => ({ name: s.name, value: s.pk }));

        if (!hasSiteOptionValue(filterSites.value, sitePk.value)) {
          const defaultSiteValue = getSiteValueFromCurrentUrl(
            filterSites.value
          );
          if (defaultSiteValue !== null) {
            sitePk.value = defaultSiteValue;
          }
        }

        if (!siteFilterInitialized.value) {
          siteFilterInitialized.value = true;
          getCubes();
        }
      }
    );

    watch(
      () => orderPk.value,
      function () {
        serverOptions.value.page = 1;
        if (orderPkTimeout) {
          clearTimeout(orderPkTimeout);
        }
        orderPkTimeout = setTimeout(() => {
          getCubes();
        }, 1000);
      }
    );

    watch(
      () => sitePk.value,
      function () {
        serverOptions.value.page = 1;
        getCubes();
      }
    );

    const getMaxPages = () => {
      if (!itemsAll.value || !serverOptions.value.rowsPerPage) return 1;
      return Math.ceil(itemsAll.value / serverOptions.value.rowsPerPage);
    };

    const clampPage = (page) => {
      const max = getMaxPages();
      if (!page || Number.isNaN(Number(page))) return 1;
      return Math.min(Math.max(1, Number(page)), max);
    };

    const selectPage = (page) => {
      serverOptions.value.page = clampPage(page);
    };

    watch(
      () => serverOptions.value.page,
      function () {
        getCubes();
      }
    );

    watch(
      () => serverOptions.value.rowsPerPage,
      function () {
        serverOptions.value.page = 1;
        getCubes();
      }
    );

    return {
      canAddMontage,
      canDisplaySites,
      items,
      itemsAll,
      loading,
      mActions,
      isFiltersOpen,
      isMainOpen,
      orderPk,
      sitePk,
      filterSites,
      serverOptions,
      selectPage,
      clampPage,
    };
  },
  computed: {
    chevronFiltersClass() {
      return this.isFiltersOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronMainClass() {
      return this.isMainOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
  },
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}
.ibox-toggle:hover {
  color: #333;
}
</style>
